// extracted by mini-css-extract-plugin
export default {"img":"styles_img__ZGLo2"};